import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@core/services/core/base.service';
import { MultiMapLoginResponse, MultiMapLoginTokenResponse, MultiMapRegisterResponse, MultiMapRegisterTokenResponse } from '@models/multimap';

@Injectable({
  providedIn: 'root'
})
export class MultiMapService {
  constructor(
    private http: HttpClient,
    private base: BaseService,
  ) { }

  getMultiMapLoginToken(policyNumber?: string) {
    const url = `${this.base.getPrivateOIMBaseUrl()}/homeOtherPolicies/multimap/loginToken`;
    const headers = this.base.getPrivateOIMHeaders();
    const body = {} as { policyNumber?: string };
    if (policyNumber) {
      body.policyNumber = policyNumber;
    }
    return this.http.post<MultiMapLoginTokenResponse>(url, body, headers);
  }

  loginMultiMap(validationToken: string, body: MultiMapLoginTokenResponse) {
    const url = `${this.base.getMultiMapBaseUrl()}/aci/sso/login`;
    const headers = new HttpHeaders()
      .append('Authorization', validationToken);
    return this.http.post<MultiMapLoginResponse>(url, body, { headers });
  }

  getMultiMapRegisterToken(policyNumber?: string) {
    const url = `${this.base.getPrivateOIMBaseUrl()}/homeOtherPolicies/multimap/registerToken`;
    const headers = this.base.getPrivateOIMHeaders();
    const body = {} as { policyNumber?: string };
    if (policyNumber) {
      body.policyNumber = policyNumber;
    }
    return this.http.post<MultiMapRegisterTokenResponse>(url, body, headers);
  }

  registerMultiMap(validationToken: string, body: MultiMapRegisterTokenResponse) {
    const url = `${this.base.getMultiMapBaseUrl()}/aci/sso/register`;
    const headers = new HttpHeaders()
      .append('Authorization', validationToken);
    return this.http.post<MultiMapRegisterResponse>(url, body, { headers });
  }
}
